import AllActions from "@/infrastructure/rootAction";
import produce from "immer";
import { getType } from "typesafe-actions";
import * as A from "./actions";
import * as IntType from "./types";

const defaultState: IntType.Store = {
  sidebarCollapsed: true,
  presentMode: false,
  isFullScreen: false,
  tickers: [],
  exchange: "",
  status: {
    tickers: "SUCCESS"
  }
};

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.setSidebarCollapsed): {
        draft.sidebarCollapsed = action.payload;
        break;
      }

      case getType(A.setPresentMode): {
        draft.presentMode = action.payload;
        break;
      }

      case getType(A.setFullScreen): {
        draft.isFullScreen = action.payload;
        break;
      }

      case getType(A.updateExchange):
        draft.exchange = action.payload
        break;

      case getType(A.fetchTickers.request):
        draft.status.tickers = "REQUEST";
        break;
      case getType(A.fetchTickers.failure):
        draft.status.tickers = "FAILURE";
        break;
      case getType(A.fetchTickers.success):
        draft.status.tickers = "SUCCESS";
        draft.tickers = action.payload;
        break;
    }
  });
